import lacrosse from '../imagenes/cateLacrosse.jpg'
import general from '../imagenes/general.jpg'

export const categorias = [
    {
        imagen: lacrosse, categoria: 'lacrosse'
    },
    {
        imagen: general, categoria: 'general'
    },
    {
        imagen: lacrosse, categoria: 'lacrosse'
    },
    {
        imagen: general, categoria: 'general'
    }
]